// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import getRandomFact from './GoalFactGenerator';
import {
  FactSection, Container, Title, Description,
} from './Styles';

const Facts = () => {
  const { t } = useTranslation();

  return (
    <FactSection>
      <Container>
        <Title>{t('goal_facts_title')}</Title>
        <Description>{t(getRandomFact().text)}</Description>
      </Container>
    </FactSection>
  );
};

export default Facts;
